import ManageDomainView from '@/views/domains/ManageDomainView.vue'
import AddDomainView from '@/views/domains/AddDomainView.vue'

const prefix = '/:siteId/domains'

export default [
  {
    name: 'manageDomain',
    path: prefix,
    component: ManageDomainView,
    title: 'domains.manageDomain.title'
  },
  {
    name: 'addDomain',
    path: `${prefix}/new`,
    component: AddDomainView,
    title: 'domains.addDomain.title'
  }
]
